import { render, staticRenderFns } from "./SamluserCreate.vue?vue&type=template&id=67549976"
import script from "./SamluserCreate.vue?vue&type=script&lang=js"
export * from "./SamluserCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports